module.exports = __webpack_public_path__ + "static/media/SWEResume.317aa9be.pdf";